<template>
  <div class="user flex-end">
    <div v-if="token && !isWhite" class="flex-row user-avatar-dropdown">
      <div style="display: inline; margin-right: 20px">欢迎你</div>
      <Dropdown @on-click="handleClick">
        <div class="flex-row">
          <div style="margin-left: 5px; max-width: 120px" class="ellipsis">
            {{ currentType === "merchant" ? account : username }}
          </div>
          <Icon :size="18" type="md-arrow-dropdown"></Icon>
        </div>

        <DropdownMenu slot="list">
          <DropdownItem v-if="currentType !== 'plat'" name="handleInfo"
            >个人信息</DropdownItem
          >
          <!-- <DropdownItem name="handleMobile">修改手机号</DropdownItem> -->
          <DropdownItem v-if="currentType === 'merchant'" name="handleRecord"
            >购买记录</DropdownItem
          >
          <DropdownItem name="handleLogout">退出登录</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <div v-else class="flex-row">
      <a class="jumpName" href="https://www.growingcloud.cn/" target="blank"
        >官网</a
      >
      <!-- <div class="ml-20 jumpName">代理商平台</div> -->
    </div>

    <Modal
      class="user-modal"
      v-model="mobileModal"
      title="修改手机号"
      :closable="false"
      :mask-closable="false"
    >
      <div class="flex-row">
        <div class="title-7">原手机号：</div>
        <Input placeholder="请输入原手机号" style="width: 300px" />
      </div>
      <div class="flex-row mt-20">
        <div class="title-7">原手机号验证码：</div>
        <div class="flex-row">
          <Input placeholder="请输入原手机号验证码" style="width: 160px" />
          <Button class="ml-20 send-btn">发送</Button>
        </div>
      </div>
      <div class="flex-row mt-20">
        <div class="title-7">新手机号：</div>
        <Input placeholder="请输入新手机号" style="width: 300px" />
      </div>
      <div class="flex-row mt-20">
        <div class="title-7">新手机号验证码：</div>
        <div class="flex-row">
          <Input placeholder="请输入新手机号验证码" style="width: 160px" />
          <Button class="ml-20 send-btn">发送</Button>
        </div>
      </div>
      <div slot="footer">
        <Button class="default-btn" @click="cancelMobile">取消</Button>
        <Button class="primary-btn" @click="saveMobile">确定</Button>
      </div>
    </Modal>

    <Modal
      class="user-modal"
      v-model="recordModal"
      title="购买记录"
      :mask-closable="false"
      footer-hide
      width="650"
    >
      <div v-if="spinning" class="flex-center">
        <Spin size="large"></Spin>
      </div>
      <template v-else>
        <div v-if="recordList.length" class="pt-20 pb-40">
          <Table :columns="columns" :data="recordList"></Table>
        </div>
        <div v-else class="flex-column flex-row pt-60 pb-100">
          <img src="@/assets/images/record_empty.png" class="empty-img" />
          <div class="mt-30 empty-tip">暂无购买记录</div>
        </div>
      </template>
    </Modal>

    <Modal
      class="user-modal"
      v-model="infoModal"
      title="个人信息"
      @on-cancel="cancelInfo"
      :mask-closable="false"
    >
      <div class="flex-row">
        <div class="title-5">公司名称</div>
        <Input
          v-if="infoEdit"
          v-model.trim="company"
          placeholder="请输入公司名称"
          style="width: 300px"
        />
        <div v-else style="width: 300px">{{ company }}</div>
      </div>
      <div class="flex-row mt-20">
        <div class="title-5">联系人姓名</div>
        <Input
          v-if="infoEdit"
          v-model.trim="username"
          placeholder="请输入联系人姓名"
          style="width: 300px"
        />
        <div v-else style="width: 300px">{{ username }}</div>
      </div>
      <div slot="footer">
        <template v-if="infoEdit">
          <Button class="default-btn" @click="cancelInfo">取消</Button>
          <Button class="primary-btn" @click="saveInfo" :loading="infoLoading"
            >确定</Button
          >
        </template>
        <Button v-else class="primary-btn" @click="editInfo">修改</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getToken, getCurrentType } from "@/libs/util";
import { orderApi, appApi, agentApi } from "@/api";
import { appInfo, expirationObj } from "@/views/purchase/config";
import { mapActions } from "vuex";
export default {
  name: "User",

  data() {
    return {
      token: getToken(),
      mobileModal: false,
      recordModal: false,
      infoModal: false,
      columns: [
        {
          title: "购买服务",
          key: "appType",
          align: "center",
        },
        {
          title: "购买时长",
          key: "duration",
          align: "center",
        },
        {
          title: "支付金额",
          key: "amount",
          align: "center",
        },
        {
          title: "下单时间",
          key: "paidAt",
          align: "center",
          width: 300,
        },
      ],
      recordList: [],
      account: "",
      spinning: false,
      appInfo,
      expirationObj,
      infoEdit: false,
      company: "",
      username: "",
      infoLoading: false,
      api: appApi,
      currentType: "merchant",
      isWhite: true,
    };
  },

  watch: {
    $route: "getInfo",
  },

  created() {
    let type = getCurrentType();
    this.currentType = type;
    switch (type) {
      case "merchant":
        this.api = appApi;
        break
      case "agent":
        this.api = agentApi;
        break
    }
  },

  mounted() {
    this.getInfo();
  },

  methods: {
    ...mapActions(["LogOut"]),
    getName() {
      let name = this.$store.state.user.userName;
      console.log(name);
      if (name) {
        name = `${name.slice(0, 3)}****${name.slice(7, 11)}`;
        this.account = name;
      }
    },

    getInfo() {
      let name = this.$route.name;
      if (this.$config.USER_WHITE.includes(name)) {
        this.isWhite = true;
        return;
      } else {
        this.isWhite = false;
      }
      if (this.currentType === "plat") {
        this.username = "admin";
        return;
      }
      this.api.getInfo().then((res) => {
        if (res.code === 0) {
          let data = res.result || {}
          this.company = data.company || "";
          this.username = data.username || "";
          if (this.currentType === "merchant") {
            this.getName();
          }
        }
      });
    },

    // 通过父组件main检查路由变化状态来调用
    checkToken() {
      this.token = getToken();
      this.getName();
    },

    handleClick(name) {
      switch (name) {
        case "handleInfo":
          this.handleInfo();
          break;
        case "handleMobile":
          this.handleMobile();
          break;
        case "handleRecord":
          this.handleRecord();
          break;
        case "handleLogout":
          this.handleLogout();
          break;
      }
    },

    handleInfo() {
      this.getInfo();
      this.infoModal = true;
    },

    handleMobile() {
      this.mobileModal = true;
    },

    handleRecord() {
      this.recordModal = true;
      this.spinning = true;
      orderApi.orderList().then((res) => {
        this.spinning = false;
        if (res.code === 0) {
          let list = res.result || [];
          this.recordList = list.map((item) => {
            item.appType = this.appInfo[item.buyAppType].name;
            item.duration = this.expirationObj[item.purchaseMonth];
            item.amount = `￥${(item.payAmount / 100).toFixed(2)}`;
            return item;
          });
        }
      });
    },

    handleLogout() {
      this.LogOut().then((res) => {
        this.$router.push({ name: this.$config.LOGIN_PAGES[getCurrentType()] });
      });
    },

    cancelMobile() {
      this.mobileModal = false;
    },

    saveMobile() {},

    cancelInfo() {
      this.infoModal = false;
      this.infoEdit = false;
      this.getInfo();
    },

    saveInfo() {
      let { company, username } = this;
      if (!company) {
        this.$Message.warning("请输入公司名称");
        return;
      }
      if (!username) {
        this.$Message.warning("请输入联系人姓名");
        return;
      }
      let p = {
        company,
        username,
      };
      this.infoLoading = true;
      this.api.updateInfo(p).then((res) => {
        this.infoLoading = false;
        if (res.code === 0) {
          this.$Message.success("修改成功");
          this.cancelInfo();
        } else {
          this.$Message.error(res.errorMsg);
        }
      });
    },

    editInfo() {
      this.infoEdit = true;
    },
  },
};
</script>

<style lang="less" scoped>
.user {
  width: 210px;
  &-avatar-dropdown {
    cursor: pointer;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 22px;
  }

  .ivu-dropdown-item {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
  }
}

.jumpName {
  height: 22px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 22px;
  cursor: pointer;
}

.user-modal {
  .send-btn {
    width: 120px;
    color: #666;
    background: #eee;
    border-color: transparent;
  }

  .primary-btn {
    background: linear-gradient(153deg, #975eec 0%, #623ea5 100%) !important;
    color: #fff;
    &:hover,
    &:active {
      border-color: #975eec !important;
    }
  }

  .default-btn {
    &:hover {
      color: #515a6e;
      border-color: #fff;
    }
  }

  .empty-img {
    width: 250px;
    height: 150px;
  }
}
</style>

<style lang="less">
.user-modal {
  .ivu-modal-header,
  .ivu-modal-footer {
    background: #eee;
  }
}
</style>